<template>
  <div>
    <div class="jumbotron">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Home</a></li>
        <li class="breadcrumb-item">HeliumDevLatestCLI</li>
      </ol>
    </div>
    <blockquote class="blockquote">
      <form>
        <fieldset>
          <label class="control-label" for="readOnlyInput">Download the latest version of the Helium Dev Client and the "no ui" version of the Helium Dev Client</label>
          <div class="input-group">
            <span class="input-group-addon" id="basic-addon1">$</span>
            <input class="form-control" id="readOnlyInput" type="text" :placeholder="textBlock" readonly="">
          </div>
           <button id="copyToClipBtn"
              type="button"
              class="btn btn-primary"
              data-toggle="tooltip"
              title="Copy Install Script to Clipboard"
              v-clipboard:copy="textBlock"
              v-clipboard:success="onCopy">
                <i class="fa fa-clipboard"></i> To clipboard
            </button>
          <div class="dev-group">
            <label class="control-label" for="readOnlyInput">Latest version of the Helium Dev Client</label>
          </div>
          <button type="button"
              class="btn btn-warning">
              <a :href="heliumDevAppUri">
                <i class="fa fa-download" aria-hidden="true"></i> Get JAR
              </a>
            </button>
          <div class="no-ui-group">
          <label class="control-label" for="readOnlyInput">Latest version of the "no ui" Helium Dev Client</label>
          </div>
          <button type="button"
            class="btn btn-warning">
            <a :href="noUIHeliumDevAppUri">
              <i class="fa fa-download" aria-hidden="true"></i> Get JAR
            </a>
          </button>
        </fieldset>
      </form>
    </blockquote>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data: function () {
      return {
        textBlock: 'curl https://portal.heliumapps.com/static/deploy-helium-dev.sh | bash',
        heliumDevAppUri: '',
        noUIHeliumDevAppUri: ''
      }
    },
    methods: {
      getUri: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/he-latest-release-version'
        // console.log(endpoint)
        vm.$parent.loading = true
        vm.axios.get(endpoint)
          .then(function (response) {
            vm.$parent.loading = false
            var version = response.data
            var releasePath = '/release-latest/HeliumDev-app-'
            vm.heliumDevAppUri = vm.$parent.baseUrl + releasePath + version + '-jar-with-dependencies.jar'
            vm.noUIHeliumDevAppUri = vm.$parent.baseUrl + releasePath + version + '-no-ui-jar-with-dependencies.jar'
          })
          .catch(function (error) {
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error, type: 'error' })
            console.log(error)
          })
      },
      onCopy: function () {
        let vm = this
        vm.$Simplert.open({ title: 'Copied', message: 'Paste me into terminal!', type: 'success' })
      }
    },
    created () {
      let vm = this
      vm.getUri()
    }
  }
</script>

<style scoped>
.btnGroupPadding {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// HeliumDevLatestCLI.vue?94ff0f64